import { c as _c } from "react/compiler-runtime";
import type { ShopPromotionMessage } from "../promotion-messaging";
import React from "react";
import { FiCheckCircle, FiPlus, FiTag } from "react-icons/fi";
import Button from "@/components/ui/button";
import { cx } from "@/lib/tailwind-utils";
import type { PublicShopPromotion } from "@/types/shop";
interface PromotionProgressProps {
  messages: ShopPromotionMessage[];
  onAddGift?: (offer: PublicShopPromotion) => void;
  className?: string;
}
export default function PromotionProgress(t0) {
  const $ = _c(10);
  const {
    messages,
    onAddGift,
    className
  } = t0;
  if (messages.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cx("space-y-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== messages || $[3] !== onAddGift) {
    let t3;
    if ($[5] !== onAddGift) {
      t3 = message => {
        const unlocked = message.status === "unlocked";
        const Icon = unlocked ? FiCheckCircle : FiTag;
        const {
          giftOffer
        } = message;
        return <div key={message.id} className={cx("flex items-start gap-2 rounded-xl border px-3 py-2.5 text-caption leading-5", giftOffer && onAddGift && "flex-wrap items-center", unlocked ? "border-status-success-text/20 bg-status-success-bg text-status-success-text" : "border-primary/20 bg-primary/5 text-foreground")}><Icon className={cx("mt-0.5 h-4 w-4 flex-none", unlocked ? "text-status-success-text" : "text-primary")} /><span className="min-w-32 flex-1">{message.text}</span>{giftOffer && onAddGift && <Button variant="secondary" onClick={() => onAddGift(giftOffer)} className="h-8 cursor-pointer gap-2 whitespace-nowrap px-3 text-caption"><FiPlus aria-hidden={true} /><span>Add free {giftOffer.giftItemName}</span></Button>}</div>;
      };
      $[5] = onAddGift;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = messages.map(t3);
    $[2] = messages;
    $[3] = onAddGift;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className={t1} aria-live="polite" aria-label="Promotion progress">{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}